const Header = ({ user }) => {
  const initials = `${user?.FirstName?.charAt(0) ?? ''}${user?.LastName?.charAt(0) ?? ''}`;

  return (
    <div className="profile-card-header flex flex-col items-center text-center mb-4">
        <div className="profile-card-avatar          
          bg-personalized text-white
          rounded-full
          w-16 h-16
          flex items-center justify-center
          flex-none
          font-bold
          text-2xl leading-none
          mb-3
        ">
          {initials}
        </div>
        <div className="min-w-0 w-full">
          <h2 className="profile-card-name text-lg font-bold break-words text-gray-700 leading-tight">{user?.FirstName} {user?.LastName ?? ''}</h2>
          <p className="text-sm break-all text-gray-500 leading-snug mt-0.5">{user?.PrincipalEmail}</p>
        </div>
      </div>   
  );
};

export default Header;
